var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('HotelListCard',{attrs:{"hotel":_vm.placeholderHotel,"hotel-image-override":_vm.placeholderImage,"hotel-sponsored-level-override":_vm.sponsoredLevel}})
}
var staticRenderFns = []

export { render, staticRenderFns }